export default function getHeightOfMinutes(minutes: number) {
    return (minutes * 2112) / 1440;
}
